export default __webpack_public_path__ + "static/media/polaroid_SmeatonsTower.c2cdea50.png";